@if (formFieldSignal(); as formField){
    @if((hasAiLicense$ | async)){
        <div class="group mx-auto flex w-full max-w-lg items-center justify-center">
            <div class="relative z-10 flex w-full cursor-pointer items-center overflow-hidden rounded-[0.6rem] p-[1.5px]">
                <div [ngClass]="{'invisible' : !formField?.AiLoading}" class="animation-rotate absolute inset-0 h-full w-full rounded-full bg-[conic-gradient(#139cd8_20deg,transparent_120deg)]"></div>
                <div class="relative z-20 flex w-full rounded-[0.60rem] bg-none p-[0.1px]"><!--[disabled]="btnLoading || formField.IsReadOnly || readOnlyOverride"-->
                    <button class="button form relative" [disabled]="formField?.AiLoading || readOnlyOverride || formField.IsReadOnly" (click)="aiButton()">
                        <p>{{ formField.Caption }}</p> <!---->
                        <i class="text-xl fa-solid fa-microchip-ai"></i>
                    </button>
                </div>
            </div>
        </div>
    }
}